<template>
    <div class="model-3d-container" v-loading="loading">
        <div class="huanse" v-if="false">
            <div>
                <button class="btn-tietu" @click="set_guqiang_inner_1()">鼓腔内侧-材质-原木1</button>
                <button class="btn-tietu" @click="set_guqiang_inner_2()">鼓腔内侧-材质-原木2</button>
                <button class="btn-tietu" @click="set_guqiang_outer_real_1()">鼓腔外侧-材质颜色切换 real1</button>
                <button class="btn-tietu" @click="set_guqiang_outer_real_2()">鼓腔外侧-材质颜色切换 real2</button>
                <button class="btn-tietu" @click="set_guqiang_outer_real_3()">鼓腔外侧-材质颜色切换 real3</button>

                <!-- <button class="btn-tietu" @click="set_guqiang_outer_gaoguang_yaguang()">
          鼓腔外侧-材质 高光哑光切换
        </button> -->

                <button class="btn-gupi" @click="set_digu_gongming_fangshoupi()">设置底鼓-共鸣面-仿兽皮</button>
                <button class="btn-gupi" @click="set_other_gu_transparent()">设置-其它-透明鼓皮</button>

                <button class="btn-gupi" @click="change_model_url()">设置-模型url切换</button>
            </div>
        </div>

        <!-- <div class="light-box">
      <div class="light-item">
        <div class="light-title">环境光 AmbientLight</div>
        <div class="light-color">
          <div class="label">颜色</div>
          <div class="value">
            <el-input v-model="AmbientLight_color" type="color"></el-input>
          </div>
        </div>
        <div class="light-slider">
          <div class="label">强度</div>
          <div class="value">
            <el-slider
              v-model="AmbientLight_intensity"
              show-input
              :min="AmbientLight_intensity_min"
              :max="AmbientLight_intensity_max"
              :step="0.1"
              @change="AmbientLight_intensity_change"
            >
            </el-slider>
          </div>
        </div>
        <div class="light-slider">
          <div class="label">移除环境光</div>
          <div class="value">
            <el-button @click="AmbientLight_remove()">移除</el-button>
          </div>
        </div>
      </div>

      <div class="light-item">
        <div class="light-title">PointLight 点光源</div>
        <div class="light-slider">
          <el-slider
            v-model="PointLight_value"
            show-input
            :min="0"
            :max="100"
            :step="0.1"
          >
          </el-slider>
        </div>
      </div>
    </div> -->
        <div id="WebGL-output" v-if="show3d" class="webGlDiv" :style="{ top: planeTop }"></div>
    </div>
</template>
<script>
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import { RoomEnvironment } from 'three/examples/jsm/environments/RoomEnvironment.js'

let scene, camera, renderer, control

let model_loader, currentModel, model

let glossyMaterialInstance
let matteMaterialInstance

let ambitlight
let dirLight
let spotLight

import { Loading } from 'element-ui'

let lastTime = 0
const targetFPS = 30 // 降低帧率以减少资源消耗
export default {
    name: 'model-3d',
    components: {},
    data() {
        return {
            Loading,
            loading: true,

            show3d: true,

            camera_info: {
                fov: 60,
                // fov: 43,
                // aspect: window.innerWidth / (container_height || window.innerHeight),
                // aspect: 1400 / (532 || 1080),
                aspect: 930 / (540 || 1080),
                // aspect: 1400 / 532,
                // aspect: 820 / 308,
                near: 0.25,
                far: 1000,
                x: 18,
                y: -10,
                z: -6,
            },

            decodePath: process.env.NODE_ENV === 'development' ? '/draco/' : '/dist_pc/draco/',

            chicun_list: [
                // 4鼓尺寸
                '12 * 8',
                '14 * 6 ',
                '14 * 13 ',
                '18 * 14',

                // 5鼓尺寸
                '10 * 7',
                '12 * 8',
                '14 * 5.5 ',
                '14 * 12',
                '20 * 14',

                // 6鼓尺寸列
                '10 * 7',
                '12 * 8',
                '14 * 6.5',
                '14 * 16',
                '16 * 16',
                '20 * 18',

                // 7鼓尺寸列
                '7 * 7',
                '10 * 7',
                '12 * 8',
                '14 * 6.5',
                '14 * 16',
                '16 * 16',
                '20 * 18',
            ],

            no_repeat_chicun_list: [
                '7 * 7',
                '10 * 7',
                '14 * 5.5',
                '14 * 6',
                '14 * 6.5',
                '12 * 8',
                '14 * 12',
                '14 * 13',
                '14 * 16',
                '16 * 16',
                '18 * 14',
                '20 * 14',
                '20 * 18',
            ],

            model_url: 'https://hailungushang.oss-cn-beijing.aliyuncs.com/4_TH700-processed.gltf',

            need_clone_medh_name: '外筒',
            target_guqiang_mesh_name: '外筒', //目标鼓皮名字
            target_neice_mesh_name: '内筒', //目标鼓皮名字

            // 底鼓打击面透明  共鸣面仿兽皮带新LOGO
            // 军鼓的上面是白色，下面是透明的
            // 通鼓上下面都是透明
            target_digu_daji_name: '底鼓打击面',
            target_digu_gongming_name: '底鼓共鸣皮',
            target_other_transparent_name: '透明鼓皮',
            target_other_transparent_name_map: {
                黑: 1,
                镀铬: 1,
                内筒: 1,
                底鼓外筒: 1,
                外筒: 1,
                白鼓皮: 1,
                底鼓打击面: 1,
                底鼓共鸣皮: 1,
                // 透明鼓皮: 1,
            },

            is_use_env_image: true, //是否使用环境贴图
            is_use_env_hdr: true, //是否使用hdr图片作为环境贴图 否-选择6张图拼接全景
            is_use_env_to_background: false, //是否使用贴图作为背景
            is_use_env_to_material: false, //是否使用贴图作为材质环境贴图

            //基本参数
            scene: null,

            //光照参数
            ambitlight: null, //环境光
            dirLight: null,
            //光照参数

            //环境光
            AmbientLight_color: '#ffffff',
            AmbientLight_intensity: 0.5, //过低的intensity值则可能使场景看起来过于暗淡 过高的intensity值可能会导致场景中的物体看起来过于明亮，甚至产生不自然的“曝光过度”效果
            AmbientLight_intensity_min: 0,
            AmbientLight_intensity_max: 10, //在实际应用中，为了保持场景的照明效果自然且不过于极端，通常会将intensity的值设置在一个相对合理的范围内，比如0.1到10之间

            //点光源
            PointLight_value: 1,

            test_tu_index: 1,
            metalness: 0, //金属度  非金属 0 - 1 金属
            roughness: 1, //粗糙度  光滑 0 - 1 粗糙

            material_view: '高光', //高光 哑光

            planeTop: '0px',

            transparentType: '鼓皮', // 透明类型：全部 / 鼓皮
        }
    },
    computed: {},
    watch: {},
    created() {},
    beforeDestroy() {
        this.disposeThreeJS()
        this.show3d = false
    },
    mounted() {
        this.init_model()
    },
    methods: {
        changeTop(plane) {
            if (plane == 1) {
                this.planeTop = '0px'
            } else if (plane == 2) {
                this.planeTop = '10px'
            } else if (plane == 3) {
                this.planeTop = '20px'
            } else if (plane == 4) {
                this.planeTop = '20px'
            }
        },
        disposeThreeJS() {
            if (renderer) {
                renderer.dispose()
                renderer = null
            }

            if (scene) {
                // 遍历场景中的所有对象并销毁它们
                scene.traverse((object) => {
                    if (object.isMesh) {
                        object.geometry.dispose()
                        object.material.dispose()
                    } else if (object.isLight) {
                        // 处理光源（如果有的话）
                    }
                    // 其他类型的对象也可以在这里处理
                })
                scene = null
            }
            if (model) {
                // 如果有额外的模型资源需要处理，可以在这里添加代码
                model = null
            } // 销毁其他资源，如纹理、材质库等（如果有的话）
        },
        animate() {
            if (!this.renderer) {
                return
            }
            requestAnimationFrame(this.animate)
            this.controls.update() // 更新控制器状态
            TWEEN.update()
            this.renderer.render(this.scene, this.camera)
        },
        // 谷歌3d模型在线调试 https://modelviewer.dev/editor/
        /**
         *3d模型需要处理的问题
         * 1 diy时勾选对应的选项 需要给鼓皮上色 包括内外鼓皮
         * 2 初始化模型时需要一个环境贴图
         * 3 鼓皮需要可以设置为透明
         * 4 鼓皮仿兽皮的质地
         * 5 鼓腔侧面整体的材质和颜色 uv映射有问题
         */

        //
        init() {},
        //设置展示模型链接
        set_model_url(url) {
            this.change_model_url(url)
        },
        //设置材质贴图-外侧
        set_gu_outer_caizhi(info) {
            let item = {
                render_type: '鼓腔',
                path_prefix: info.path_prefix || './model-box/tietu/real-1/',
                map: info.map || '7777基础.jpg',
                normal: info.normal || '7777法线.jpg',
                // roughness: info.roughness || '7777粗糙.jpg',
            }
            this.tietu_update(item)
        },
        //设置材质贴图-内侧
        set_gu_inner_caizhi(info) {
            let item = {
                path_prefix: info.path_prefix || './model-box/tietu/nei/',
                map: info.map || 'nei-1.png', //基础贴图
                meshName: this.target_neice_mesh_name,
            }
            this.tietu_update(item)
        },
        //初始化模型
        init_model() {
            this.init_scene()
            this.load_model()

            setTimeout(() => {
                // this.loading = false
            }, 4000)
        },

        init_scene() {
            window.THREE = THREE

            let container_info = document.querySelector('#WebGL-output').getBoundingClientRect()
            let container_height = window.innerHeight || container_info.height // window.innerHeight

            // 场景，相机
            scene = new THREE.Scene()
            // this.scene = scene;
            window.scene = scene
            // scene.background = new THREE.Color(0x000000);
            // const axesHelper = new THREE.AxesHelper(5) //红色：X轴  绿色：Y轴   蓝色：Z轴
            // scene.add(axesHelper)

            if (!this.is_use_env_image) {
                // 测试-环境光
                // ambitlight = new THREE.AmbientLight(0x404040);
                // ambitlight.intensity = 0.5
                // scene.add(ambitlight)
                // // //测试-平行光
                // dirLight = new THREE.DirectionalLight(0xffffff, 0.7);
                // dirLight.position.set(200, 200, 200).normalize(); // 设置光源方向
                // scene.add(dirLight);
                // // //测试-聚光灯效果
                // spotLight = new THREE.SpotLight(0xffffff, 1); // 白色光，强度为1
                // spotLight.position.set(200, 200, 200); // 设置聚光灯的位置
                // spotLight.angle = Math.PI / 4; // 设置聚光灯的照射角度（弧度）
                // spotLight.penumbra = 0.05; // 设置光晕的起始范围（相对于聚光灯角度的百分比）
                // spotLight.decay = 0; // 设置光照强度的衰减率
                // scene.add(spotLight); // 将聚光灯添加到场景中
            } else {
                // 测试-环境光
                // const ambitlight = new THREE.AmbientLight(0x404040);
                // const ambitlight = new THREE.AmbientLight(0xffffff);
                // ambitlight.intensity = 1.5
                // scene.add(ambitlight)
                // this.ambitlight = ambitlight;
                //
                //
                //
                //客户感觉木纹颜色偏嫩 灯光先关闭
                const directionalLight = new THREE.DirectionalLight(0x888888, 1) // 白色，强度为1
                // const directionalLight = new THREE.DirectionalLight(0xffffff, 3); // 白色，强度为1
                directionalLight.position.set(18, 10, -11).normalize() // 假设太阳光从右上角斜射而下，但先归一化
                scene.add(directionalLight)
            }

            // 4、加入灯光
            // const lightness = new THREE.HemisphereLight(0xffffff, 0x444444);
            // lightness.position.set(0, 20, 0);
            // scene.add(lightness);
            // const shadowLight = new THREE.DirectionalLight(0xffffff);
            // shadowLight.position.set(0, 20, 10);
            // scene.add(shadowLight);

            //点光源
            // const pointLight = new THREE.PointLight(0xffd700, 1, 100); // 黄色点光源，强度为1，距离衰减为100
            // pointLight.position.set(10, 10, 10); // 你可以根据需要调整这个位置
            // scene.add(pointLight);

            // const sunlight = new THREE.DirectionalLight(0xffffff);
            // sunlight.position.set(-20, 1, 1);
            // scene.add(sunlight);

            // scene.background = new THREE.Color(0x191919);

            // scene.background = new THREE.Color(0xffffff);
            // const hemiLight = new THREE.HemisphereLight(0xffffff, 0x444422);
            // const hemiLight = new THREE.HemisphereLight(0xeeeeee, 0xeeeeee);
            // const hemiLight = new THREE.HemisphereLight(0xbbbbff, 0x444422);
            // hemiLight.position.set(-6, 6, 1.5);
            // scene.add(hemiLight);

            //环境光
            // scene.add(new THREE.AmbientLight(0xffffff, 1));

            // 点光源
            // const pointLight = new THREE.PointLight(0xffffff, 10);
            // pointLight.position.set(10, 10, 10);//点光源放在x轴上
            // scene.add(pointLight); //点光源添加到场景中

            // 平行光
            // const directionalLight = new THREE.DirectionalLight(0xffffff, 10);
            // // 设置光源的方向：通过光源position属性和目标指向对象的position属性计算
            // directionalLight.position.set(20, -20, -20);
            // // 方向光指向对象网格模型mesh，可以不设置，默认的位置是0,0,0
            // // directionalLight.target = mesh;
            // scene.add(directionalLight);

            // 创建聚光灯
            // var spotLight = new THREE.SpotLight(0xffffff, 1); // 白色光，强度为1
            // spotLight.position.set(5, 5, 5); // 设置聚光灯的位置
            // spotLight.angle = Math.PI / 4; // 设置聚光灯的照射角度（以弧度为单位）

            // spotLight.penumbra = 0.05; // 设置聚光灯的光锥边缘的柔和度（0到1之间）
            // scene.add(spotLight);
            // spotLight.distance = 100; // 设置聚光灯的照射距离
            // spotLight.castShadow = true; // 启用阴影

            // 配置阴影属性（可选）
            // spotLight.shadow.mapSize.width = 1024; // 阴影映射的宽度
            // spotLight.shadow.mapSize.height = 1024; // 阴影映射的高度

            // 设置阴影摄像机的属性（可选）
            // spotLight.shadow.camera.near = 0.5;
            // spotLight.shadow.camera.far = 100;
            // spotLight.shadow.camera.fov = 50; // 阴影摄像机的视场角

            // 将聚光灯添加到场景中
            // const dirLight = new THREE.DirectionalLight(0xDDDDDD);
            // dirLight.position.set(100, 100, 100);
            // scene.add(dirLight);

            let camera_info = this.camera_info
            camera = new THREE.PerspectiveCamera(camera_info.fov, camera_info.aspect, camera_info.near, camera_info.far)
            camera.position.set(camera_info.x, camera_info.y, camera_info.z)
            window.camera = camera

            // const model_center_poisition = new THREE.Vector3(11.301095485687256, -6.633010387420654, 11.88792896270752); // 相机指向模型中心点
            // camera.lookAt(model_center_poisition);//
            //

            // 渲染器
            renderer = new THREE.WebGLRenderer({
                // antialias: true, //抗锯齿
                // // alpha: true
                antialias: false, // 禁用抗锯齿
                precision: 'mediump', // 使用中等精度着色器
                // alpha: true,
            })

            let is_linear = false
            //新增 渲染相关
            if (!is_linear) {
                // renderer.toneMapping = THREE.ACESFilmicToneMapping;//基于ACES（Academy Color Encoding System）色彩空间和电影级的色调映射曲线，能够产生更加真实和自然的图像效果。
                renderer.toneMapping = THREE.NeutralToneMapping //基于ACES（Academy Color Encoding System）色彩空间和电影级的色调映射曲线，能够产生更加真实和自然的图像效果。
                renderer.toneMappingExposure = 1 //属性用于设置渲染器的色调映射曝光度。曝光度是一个控制图像明亮程度的参数，在色调映射过程中起着重要作用。增加曝光度会使图像整体变亮，减少曝光度则会使图像整体变暗。这个参数的具体效果取决于场景的具体内容和光照条件。
                const environment = new RoomEnvironment(renderer)
                const pmremGenerator = new THREE.PMREMGenerator(renderer)
                // scene.background = new THREE.Color(0xffffff)
                scene.background = new THREE.Color(0xf5f5f5)
                // scene.background = new THREE.Color(0x000000);
                scene.environment = pmremGenerator.fromScene(environment).texture
                //新增 渲染相关
            }

            window.renderer = renderer
            renderer._outputColorSpace = THREE.SRGBColorSpace
            renderer.outputColorSpace = THREE.SRGBColorSpace
            // renderer.setSize(window.innerWidth, container_height)
            // renderer.setSize(1400, 532)
            renderer.setSize(930, 540)

            // document.body.appendChild(renderer.domElement);
            document.querySelector('#WebGL-output').appendChild(renderer.domElement)

            // 地表格
            //   const grid = new THREE.GridHelper(500, 100, 0xffffff, 0xffffff);
            //   grid.material.opacity = 0.5;
            //   grid.material.depthWrite = false;
            //   grid.material.transparent = true;
            //   scene.add(grid);

            // 创建点光源
            //我给您一个灯光数据您看看能不能还原：颜色：7FCCFF  强度2.64  距离我这里没有。位置（12135,19742,32378）
            // 点光001：FFB14D
            // 点光002：FFAFD1
            // 点光：69A6FF
            // let ligth_info1 = {
            //     color: 0xff7013,
            //     color: "#DDDDDD",
            //     color: "#999999",

            //     intensity: 0.86,
            //     x: 1,
            //     y: 1,
            //     z: 1,
            // }; //点光001
            // let ligth_info2 = {
            //     color: 0xff6ca2,
            //     color: "#DDDDDD",
            //     color: "#999999",

            //     intensity: 0.58,
            //     x: 1,
            //     y: 1,
            //     z: 1,
            // }; //点光002
            // let ligth_info3 = {
            //     // color: 0x2461ff,
            //     color: "#DDDDDD",
            //     intensity: 3.8,
            //     x: 1,
            //     y: 1,
            //     z: 1,
            // }; //点光

            // const pointLight1 = new THREE.PointLight(
            //     ligth_info1.color,
            //     ligth_info1.intensity,
            //     0
            // ); // 白色，强度1，距离100
            // const pointLight2 = new THREE.PointLight(
            //     ligth_info2.color,
            //     ligth_info2.intensity,
            //     0
            // ); // 白色，强度1，距离100
            // const pointLight3 = new THREE.PointLight(
            //     ligth_info3.color,
            //     ligth_info3.intensity
            // ); // 白色，强度1，距离100
            // const pointLight2 = new THREE.PointLight(0x7ffafd1, 2.64); // 白色，强度1，距离100
            // const pointLight3 = new THREE.PointLight(0x69a6ff, 2.64); // 白色，强度1，距离100

            // 定位点光源，这里只是示例，你可能需要根据模型的具体位置来设置
            // 假设你想要将光源放置在模型的中心
            // 注意：这里需要你有模型尺寸或中心点的某种知识，或者遍历模型找到中心点
            // 这里我们简单地使用场景的中心（这通常不是最佳做法）

            // pointLight1.position.set(ligth_info1.x, ligth_info1.y, ligth_info1.z); // 将光源放置在y轴上方10个单位的位置
            // pointLight2.position.set(ligth_info2.x, ligth_info2.y, ligth_info2.z); // 将光源放置在y轴上方10个单位的位置
            // pointLight3.position.set(ligth_info3.x, ligth_info3.y, ligth_info3.z); // 将光源放置在y轴上方10个单位的位置

            // // 将点光源添加到场景中
            // scene.add(pointLight1);
            // scene.add(pointLight2);
            // scene.add(pointLight3);

            // 控制器
            control = new OrbitControls(camera, renderer.domElement)
            window.control = control
            // control.enableZoom = false;  //鼠标禁止缩放
            // control.enablePan = false;  //鼠标禁止平移
            // function animate() {
            //     requestAnimationFrame(animate);
            //     renderer.render(scene, camera);
            // }

            // animate();
            this.animate()
        },

        animate(timestamp) {
            const elapsed = timestamp - lastTime

            if (elapsed > 1000 / targetFPS) {
                lastTime = timestamp
                // 更新逻辑
                renderer.render(scene, camera)
            }
            requestAnimationFrame(this.animate)
            // renderer.render(scene, camera)
        },

        disposeObject() {
            if (object.geometry) object.geometry.dispose()
            if (object.material) {
                if (Array.isArray(object.material)) {
                    object.material.forEach((m) => {
                        if (m.map) m.map.dispose()
                        if (m.normalMap) m.normalMap.dispose()
                        m.dispose()
                    })
                } else {
                    if (object.material.map) object.material.map.dispose()
                    if (object.material.normalMap) object.material.normalMap.dispose()
                    object.material.dispose()
                }
            }
            if (object.children) {
                while (object.children.length > 0) {
                    disposeObject(object.children[0])
                    object.remove(object.children[0])
                }
            }
        },

        load_model() {
            let that = this
            // const rgbeLoader = new RGBELoader()
            // rgbeLoader.loadAsync('./textures/cube/quanjing/quanjing.hdr').then((texture) => {
            // 	texture.mapping = THREE.EquirectangularReflectionMapping //正常只是一张图平铺，设置这个可以让图包围环绕整个环境
            // 	scene.background = texture //设置环境贴图
            // 	scene.environment = texture
            // })

            let file_path = ''
            let url_hdr = ''

            file_path = './model-box/env/hdr/' //文件路径
            //  url_hdr = 'quanjing2.hdr'
            //  url_hdr = 'haibian.hdr'
            // url_hdr = 'heibai.hdr'
            // url_hdr = 'jiedao.hdr'
            //  url_hdr = 'shinei.hdr'
            //  url_hdr = '01-赛道.hdr'
            //  url_hdr = '02-乒乓球室.hdr'
            //  url_hdr = '03-屋子暗.hdr'
            // url_hdr = '04-天空海洋.hdr'
            //  url_hdr = '05-录音棚.hdr'
            // url_hdr = '06-机场.hdr'
            // url_hdr = '08-村庄.hdr'
            // url_hdr = '09-室外草场.hdr'
            url_hdr = '10-浴室.hdr' //测试可以 本地测试1 需要配置一组平行光 强度 1 .set(18, 10, -11).normalize()
            // url_hdr = '11-厂房.hdr'
            // url_hdr = '11-机场.hdr'
            //
            //
            //
            //
            // file_path = './model-box/env/hdr2/';//文件路径
            // url_hdr = '1.hdr'
            // url_hdr = '2.hdr';//测试还可以 本地测试1 需要配置一组平行光 强度 1   室内 清晨阳光
            // url_hdr = '3.hdr'
            // url_hdr = '4.hdr'
            // url_hdr = '5.hdr'
            // url_hdr = '6.hdr';//测试可以  夜晚 摄影棚

            //
            //
            // file_path = './model-box/env/hdr3/';//文件路径
            // url_hdr = 'bergen_2k.hdr';//测试还可以
            // url_hdr = 'de_balie_2k.hdr';//
            // url_hdr = 'harties_2k.hdr';//暗黑场景
            // url_hdr = 'misty_dawn_2k.hdr';//测试还可以  室外 黄昏
            // url_hdr = 'old_apartments_walkway_2k.hdr';//
            // url_hdr = 'rhodes_memorial_2k.hdr';//偏暗
            // url_hdr = 'small_empty_house_2k.hdr';//
            // url_hdr = 'zhengyang_gate_2k.hdr';//
            // url_hdr = 'moulton_falls_train_tunnel_east_2k.hdr';//测试还可以 山林环境
            // url_hdr = 'signal_hill_dawn_2k.hdr';// 测试还可以 海边
            // url_hdr = 'kiara_3_morning_2k.hdr';//
            // url_hdr = 'rosendal_plains_1_2k.hdr';//测试还可以 偏黄 野外

            //
            // file_path = './model-box/env/hdr-shinei/';//文件路径
            // url_hdr = 'blocky_photo_studio_2k.hdr';//
            // url_hdr = 'christmas_photo_studio_04_2k.hdr';//测试还可以  室内 偏黄
            // url_hdr = 'christmas_photo_studio_06_2k.hdr';//测试还可以 但是灯光偏暗 还有微蓝色
            // url_hdr = 'colorful_studio_2k.hdr';// 测试也可以 光色发黄 还有微蓝色
            // url_hdr = 'hospital_room_2_2k.hdr';//
            // url_hdr = 'photo_studio_01_2k.hdr';//
            // url_hdr = 'rostock_arches_2k.hdr';//测试还可以
            // url_hdr = 'small_empty_room_1_2k.hdr';//
            // url_hdr = 'solitude_interior_2k.hdr';//测试还可以 室外 宫殿
            // url_hdr = 'squash_court_2k.hdr';//
            // url_hdr = 'unfinished_office_night_2k.hdr';//

            url_hdr = file_path + url_hdr

            let hdr_envMap = null
            let quanjing_envMap = null
            if (this.is_use_env_image) {
                if (this.is_use_env_hdr) {
                    const rgbeLoader = new RGBELoader()
                    rgbeLoader.load(url_hdr, function (envMap) {
                        envMap.mapping = THREE.EquirectangularReflectionMapping //正常只是一张图平铺，设置这个可以让图包围环绕整个环境
                        scene.environment = envMap
                        hdr_envMap = envMap

                        if (that.is_use_env_to_background) {
                            scene.background = envMap //设置环境贴图 白色场景下 可以不设置背景
                        }
                    })
                } else {
                    var path = './textures/cube/quanjing2/'
                    var format = '.jpg'
                    quanjing_envMap = new THREE.CubeTextureLoader().load([
                        path + 'posx' + format, //right
                        path + 'negx' + format, //left
                        path + 'posy' + format, //top
                        path + 'negy' + format, //down
                        path + 'posz' + format, //back
                        path + 'negz' + format, //front
                    ])
                    if (that.is_use_env_to_background) {
                        scene.background = quanjing_envMap //环境贴图
                    }
                    scene.environment = quanjing_envMap
                }
            }

            //加载模型
            model_loader = new GLTFLoader()
            const dracoLoader = new DRACOLoader()
            dracoLoader.setDecoderPath(this.decodePath)
            model_loader.setDRACOLoader(dracoLoader)
            model_loader.load(this.model_url, (gltf) => {
                //设置模型位置
                // gltf.scene.position.set(0, 0, 0);
                // 移除任何之前加载的模型
                if (currentModel) {
                    scene.remove(currentModel.scene)
                }
                // 存储当前加载的模型
                currentModel = gltf
                //
                //设置模型材质
                // gltf.scene.traverse(function (child) {
                //   if (child.isMesh && child.name == that.target_guqiang_mesh_name) {
                //     if (that.is_use_env_image) {
                //       if (that.is_use_env_to_material) {
                //         if (that.is_use_env_hdr) {
                //           child.material.envMap = hdr_envMap; //hdr 贴图
                //         } else {
                //           child.material.envMap = quanjing_envMap; //全景图-六张单图环境贴图
                //         }
                //       }
                //     }
                //   }
                // });

                gltf.scene.traverse(function (child) {
                    //克隆高光 哑光实例
                    // if (child.isMesh && child.name == that.need_clone_medh_name) {
                    //   // 假设模型只包含一个网格，且该网格只有一个材质
                    //   const originalMaterial = child.material;
                    //   //克隆原始材质以创建高光和哑光版本
                    //   //高光
                    //   glossyMaterialInstance = originalMaterial.clone();
                    //   glossyMaterialInstance.roughness = 0.1; // 设置高光效果

                    //   //哑光
                    //   matteMaterialInstance = originalMaterial.clone();
                    //   matteMaterialInstance.roughness = 0.9; // 设置哑光效果

                    //   // 初始设置为高光材质
                    //   child.material = glossyMaterialInstance;

                    //   console.warn('设置高光效果')
                    // }
                    // 高光 哑光处理

                    //设置材质环境贴图
                    if (that.is_use_env_image) {
                        if (that.is_use_env_to_material) {
                            if (child.isMesh && child.name == that.target_guqiang_mesh_name) {
                                if (that.is_use_env_hdr) {
                                    child.material.envMap = hdr_envMap //hdr 贴图
                                } else {
                                    child.material.envMap = quanjing_envMap //全景图-六张单图环境贴图
                                }
                            }
                        }
                    }
                })

                // 计算边界盒并获取中心点
                const box = new THREE.Box3().setFromObject(gltf.scene)
                const center = box.getCenter(new THREE.Vector3())
                // 输出中心点坐标到控制台（可选）
                // console.log('模型中心点坐标 Model Center:', center.x, center.y, center.z)
                camera.lookAt(center) //

                // gltf.scene.position.set(0, 0, 0);
                scene.add(gltf.scene)
                // const model_center_poisition = new THREE.Vector3(0, 0, 0); // 相机指向模型中心点
                camera.lookAt(center) //
                control.target = center

                renderer.render(scene, camera)
                model = gltf.scene
                // setTimeout(() => {
                // }, 5000)
                // that.init_gu_config_0()
            })
        },

        //模型初始化 设置木纹贴图 透明鼓皮等操作
        init_gu_config_0() {
            console.warn('初始化 模型配置 1')
            this.set_guqiang_inner_2() // 鼓腔内侧-材质-原木
            this.set_guqiang_outer_real_2() // 鼓腔外侧-材质颜色
            this.set_digu_gongming_fangshoupi() //设置底鼓-共鸣面-仿兽皮
            this.set_other_gu_transparent() //设置鼓皮透明
        },
        init_gu_config_1() {
            console.warn('初始化 模型配置 2')
            this.set_guqiang_inner_1() // 鼓腔内侧-材质-原木
            this.set_guqiang_outer_real_1() // 鼓腔外侧-材质颜色
            this.set_digu_gongming_fangshoupi() //设置底鼓-共鸣面-仿兽皮
            this.set_other_gu_transparent() //设置鼓皮透明
        },

        //鼓腔内侧-原木
        set_guqiang_inner_1() {
            let item = {
                path_prefix: './model-box/tietu/nei/',
                map: 'nei-1.png',
                meshName: this.target_neice_mesh_name,
            }
            this.tietu_update(item)
        },
        //鼓腔内侧-原木
        set_guqiang_inner_2() {
            let item = {
                path_prefix: './model-box/tietu/nei/',
                map: 'nei-2.jpg',
                meshName: this.target_neice_mesh_name,
            }
            this.tietu_update(item)
        },

        //更新模型材质和颜色 - 主要更新鼓外表面的材质和颜色渲染
        set_guqiang_outer_real_1() {
            let item = {
                render_type: '鼓腔',
                path_prefix: './model-box/tietu/real-1/',
                map: '7777基础.jpg',
                normal: '7777法线.jpg',
                roughness: '7777粗糙.jpg',

                map: '8888基础.jpg',
                normal: '8888法线.jpg',
                roughness: '8888粗糙.jpg',
            }
            this.tietu_update(item)
        },
        //更新模型材质和颜色 - 主要更新鼓外表面的材质和颜色渲染
        set_guqiang_outer_real_2() {
            let item = {
                render_type: '鼓腔',
                path_prefix: './model-box/tietu/real-1/',
                map: '基础.jpg',
                // normal: '法线.jpg',
                roughness: '粗糙.jpg',

                // map: '333基础.jpg',
                // normal: '333法线.jpg',
                // roughness: '333粗糙.jpg',
            }
            this.tietu_update(item)
        },
        //更新模型材质和颜色 - 主要更新鼓外表面的材质和颜色渲染
        set_guqiang_outer_real_3() {
            let item = {
                render_type: '鼓腔',
                path_prefix: './model-box/tietu/real-3/',
                map: `tu${this.test_tu_index}.jpg`,
                // normal: '法线.jpg',
                // roughness: "粗糙.jpg",

                metalness: this.metalness, //金属度
            }
            this.tietu_update(item)
            if (this.test_tu_index == 6) {
                this.test_tu_index = 1
                this.metalness = 0
            } else {
                this.test_tu_index++
                this.metalness = this.test_tu_index * 0.2
            }
        },

        //更新模型材质 高光 哑光效果
        set_guqiang_outer_gaoguang_yaguang() {
            let that = this
            if (model) {
                // 遍历模型的所有材质，设置新的颜色
                model.traverse((child, index) => {
                    if (child.isMesh) {
                        // console.log('模型对象', child.name, child)

                        if (child.name == that.need_clone_medh_name) {
                            if (that.material_view == '高光') {
                                //高光时 切换为哑光
                                that.material_view == '哑光'
                                child.material = matteMaterialInstance
                            } else {
                                that.material_view == '高光'
                                child.material = glossyMaterialInstance
                            }

                            // const material = child.material;
                            // // if (child.material.color) {
                            // //     child.material.color.set(0xff0000); // 设置为红色
                            // //     console.log('设置颜色为 白色')
                            // // }
                            // //1 颜色贴图
                            // if (map) {

                            // }
                            // // 2 金属度
                            // // material.metalness = 0.5; //非金属
                            // material.metalness = this.metalness; //非金属
                            // if (metalness) {

                            // }
                            child.material.needsUpdate = true // 确保three.js知道贴图已更改
                            console.warn('更新材质', that.material_view)
                        }
                    }
                })
            }
        },
        //测试 2024-10-06

        //底鼓-共鸣面-仿兽皮logo
        set_digu_gongming_fangshoupi() {
            console.log('底鼓-共鸣面-仿兽皮logo')
            let item = {
                meshName: this.target_digu_gongming_name,
                path_prefix: process.env.NODE_ENV === 'development' ? './model-box/tietu/gupi/' : './dist_pc/model-box/tietu/gupi/',
                map: 'gupi-top.png',
                normal: '',
                roughness: '',
            }
            this.gupi_init_fangshoupi(item)
        },

        //其他鼓面-透明
        set_other_gu_transparent() {
            console.log('其他鼓面-透明')
            if (this.transparentType == '全部') {
                // 选择亚克力
                this.target_other_transparent_name_map = {
                    黑: 1,
                    镀铬: 1,
                    内筒: 1,
                    底鼓外筒: 1,
                    外筒: 1,
                    白鼓皮: 1,
                    底鼓打击面: 1,
                    底鼓共鸣皮: 1,
                    // 透明鼓皮: 1,
                }
                let item = {
                    meshName: this.target_other_transparent_name,
                }
                this.gupi_transparent(item)
                // let item2 = {
                //     meshName: this.target_other_transparent_name,
                // }
                this.guqiang_transparent()
            } else {
                // 选择普通颜色
                this.target_other_transparent_name_map = {
                    黑: 1,
                    镀铬: 1,
                    内筒: 1,
                    底鼓外筒: 1,
                    外筒: 1,
                    白鼓皮: 1,
                    底鼓打击面: 1,
                    // 底鼓共鸣皮: 1,
                    // 透明鼓皮: 1,
                }
                let item = {
                    meshName: this.target_other_transparent_name,
                }
                this.gupi_transparent(item)
            }
        },

        //切换模型贴图
        tietu_update(item) {
            let that = this
            return new Promise(async (resolve, reject) => {
                let { render_type, path_prefix, map, metalness, normal, roughness } = item
                let meshName = item.meshName || this.target_guqiang_mesh_name

                // let path_prefix = './model-box/tietu2/'
                // let path_prefix = './model-box/tietu3/'

                let url_map = path_prefix + map
                let url_metalness = path_prefix + metalness
                let url_normal = path_prefix + normal
                let url_roughness = path_prefix + roughness

                if (model) {
                    // 遍历模型的所有材质，设置新的颜色
                    model.traverse((child, index) => {
                        if (child.isMesh) {
                            // console.log('模型对象', child.name, child)

                            if (child.name == meshName) {
                                const material = child.material
                                child.material.transparent = false
                                child.material.opacity = 1 //

                                if (material.map && that.transparentType == '全部') {
                                    material.map.dispose()
                                }

                                // if (child.material.color) {
                                //     child.material.color.set(0xff0000); // 设置为红色
                                //     console.log('设置颜色为 白色')
                                // }

                                //1 颜色贴图
                                if (map) {
                                    const map_texture = new THREE.TextureLoader().load(
                                        url_map
                                        // function(texture) {
                                        //     console.log('map texture2', texture)
                                        // }
                                    )

                                    //设置色彩空间编码
                                    // map_texture.encoding = THREE.sRGBEncoding;//已经弃用
                                    // map_texture.colorSpace = THREE.SRGBColorSpace //
                                    // map_texture.flipY = false;
                                    //
                                    console.log('THREE.sRGBEncoding', THREE.sRGBEncoding)
                                    console.log('map_texture', map_texture)

                                    //THREE.RepeatWrapping  1000 纹理将重复以覆盖整个表面。这是最常见的设置，用于需要纹理平铺的场景。
                                    //THREE.ClampToEdgeWrapping 1001 纹理将不会重复，而是将边缘的颜色扩展到超出其原始范围的部分。这通常用于防止纹理在边缘处出现不希望的混合效果。
                                    //THREE.MirroredRepeatWrapping 1002 纹理将像镜子一样重复，每次重复时都会翻转图像。这可以创建有趣的视觉效果，但通常不如简单的重复或钳制常用。
                                    if (render_type == '鼓腔') {
                                        console.log('控制纹理在UV方向上的包装方式')
                                        // map_texture.wrapS = THREE.ClampToEdgeWrapping //
                                        // map_texture.wrapT = THREE.ClampToEdgeWrapping //
                                        map_texture.wrapS = THREE.RepeatWrapping //
                                        map_texture.wrapT = THREE.RepeatWrapping //
                                    }

                                    if (material.map) {
                                        material.map.dispose()
                                    }
                                    material.map = map_texture
                                }

                                // material.color = 'ff0000';

                                // 2 金属度
                                // material.metalness = 0.5; //非金属
                                material.metalness = this.metalness //非金属
                                console.log('设置金属度 this.metalness', this.metalness)

                                if (metalness) {
                                    const metalnessMap_texture = new THREE.TextureLoader().load(url_metalness)
                                    // metalnessMap_texture.colorSpace = THREE.SRGBColorSpace //
                                    // metalnessMap_texture.flipY = false;
                                    if (render_type == '鼓腔') {
                                        console.log('控制纹理在UV方向上的包装方式')
                                        // metalnessMap_texture.wrapS = THREE.ClampToEdgeWrapping
                                        // metalnessMap_texture.wrapT = THREE.ClampToEdgeWrapping
                                        metalnessMap_texture.wrapS = THREE.RepeatWrapping //
                                        metalnessMap_texture.wrapT = THREE.RepeatWrapping //
                                    }

                                    if (material.metalnessMap) {
                                        material.metalnessMap.dispose()
                                    }
                                    material.metalnessMap = metalnessMap_texture
                                }

                                // //3 法线
                                if (normal) {
                                    const normalMap_texture = new THREE.TextureLoader().load(url_normal)
                                    // normalMap_texture.colorSpace = THREE.SRGBColorSpace //
                                    // normalMap_texture.flipY = false;

                                    if (render_type == '鼓腔') {
                                        console.log('控制纹理在UV方向上的包装方式')
                                        // normalMap_texture.wrapS = THREE.ClampToEdgeWrapping // 纹理在水平方向上重复
                                        // normalMap_texture.wrapT = THREE.ClampToEdgeWrapping // 纹理在垂直方向上钳制到边缘（对于圆柱体，这通常意味着不重复）
                                        normalMap_texture.wrapS = THREE.RepeatWrapping // 纹理在水平方向上重复
                                        normalMap_texture.wrapT = THREE.RepeatWrapping // 纹理在垂直方向上钳制到边缘（对于圆柱体，这通常意味着不重复）
                                    }

                                    if (material.normalMap) {
                                        material.normalMap.dispose()
                                    }
                                    material.normalMap = normalMap_texture
                                }

                                // //4 粗糙度贴图
                                if (roughness) {
                                    const roughnessMap_texture = new THREE.TextureLoader().load(url_roughness)
                                    // roughnessMap_texture.colorSpace = THREE.SRGBColorSpace //
                                    // roughnessMap_texture.flipY = false;

                                    if (render_type == '鼓腔') {
                                        console.log('控制纹理在UV方向上的包装方式')
                                        // roughnessMap_texture.wrapS = THREE.ClampToEdgeWrapping // 纹理在水平方向上重复
                                        // roughnessMap_texture.wrapT = THREE.ClampToEdgeWrapping // 纹理在垂直方向上钳制到边缘（对于圆柱体，这通常意味着不重复）
                                        roughnessMap_texture.wrapS = THREE.RepeatWrapping // 纹理在水平方向上重复
                                        roughnessMap_texture.wrapT = THREE.RepeatWrapping // 纹理在垂直方向上钳制到边缘（对于圆柱体，这通常意味着不重复）
                                    }
                                    if (material.roughnessMap) {
                                        material.roughnessMap.dispose()
                                    }
                                    material.roughnessMap = roughnessMap_texture
                                }

                                child.material.needsUpdate = true // 确保three.js知道贴图已更改
                            }
                        }
                    })
                    resolve()
                } else {
                    resolve()
                }
            })
        },

        //设置鼓皮透明
        gupi_init_fangshoupi(item) {
            let { render_type, path_prefix, map, metalness, normal, roughness } = item
            let meshName = item.meshName || this.target_digu_gongming_name

            let url_map = path_prefix + map
            let url_metalness = path_prefix + metalness
            let url_normal = path_prefix + normal
            let url_roughness = path_prefix + roughness

            if (model) {
                // 遍历模型的所有材质，设置新的颜色
                model.traverse((child, index) => {
                    if (child.isMesh) {
                        // console.log('模型对象', child.name, child)

                        if (child.name == meshName) {
                            const material = child.material

                            // if (child.material.color) {
                            //     child.material.color.set(0xff0000); // 设置为红色
                            //     console.log('设置颜色为 白色')
                            // }

                            //1 颜色贴图
                            if (map) {
                                const map_texture = new THREE.TextureLoader().load(
                                    url_map
                                    // function(texture) {
                                    //     console.log('map texture2', texture)
                                    // }
                                )

                                //设置色彩空间编码
                                // map_texture.encoding = THREE.sRGBEncoding;//已经弃用
                                map_texture.colorSpace = THREE.SRGBColorSpace //
                                map_texture.flipY = false
                                //
                                console.log('THREE.sRGBEncoding', THREE.sRGBEncoding)
                                console.log('map_texture', map_texture)

                                //THREE.RepeatWrapping  纹理将重复以覆盖整个表面。这是最常见的设置，用于需要纹理平铺的场景。
                                //THREE.ClampToEdgeWrapping 纹理将不会重复，而是将边缘的颜色扩展到超出其原始范围的部分。这通常用于防止纹理在边缘处出现不希望的混合效果。
                                //THREE.MirroredRepeatWrapping 纹理将像镜子一样重复，每次重复时都会翻转图像。这可以创建有趣的视觉效果，但通常不如简单的重复或钳制常用。
                                if (render_type == '鼓腔') {
                                    console.log('控制纹理在UV方向上的包装方式')
                                    map_texture.wrapS = THREE.ClampToEdgeWrapping //
                                    map_texture.wrapT = THREE.ClampToEdgeWrapping //
                                }

                                material.map = map_texture
                                material.side = THREE.DoubleSide // 设置双面渲染  ;
                            }

                            child.material.needsUpdate = true // 确保three.js知道贴图已更改
                        }
                    }
                })
            }
        },

        //设置鼓皮透明
        gupi_transparent(item) {
            // return
            let { meshName, type } = item
            if (model) {
                model.traverse((child, index) => {
                    if (child.isMesh) {
                        // console.log('模型对象', child)

                        if (child.name == meshName) {
                            // let map_path = "model-box/transparent/transparent2.png";
                            // const material = child.material;
                            // const map_texture = new THREE.TextureLoader().load(
                            //   map_path
                            // );
                            // material.map = map_texture;
                            child.material.transparent = true
                            child.material.opacity = 0.5 // 设置透明度为0.5（半透明）
                            // child.material.alphaTest = 0; // 禁用alphaTest（如果需要的话）
                        } else {
                            child.material.transparent = false
                            child.material.opacity = 1
                        }
                    }
                })
            }
        },

        //设置鼓腔透明
        guqiang_transparent(item) {
            let that = this
            // let { meshName, type } = item
            if (model) {
                model.traverse((child, index) => {
                    if (child.isMesh) {
                        // console.log('模型对象', child)
                        if (that.target_other_transparent_name_map[child.name]) {
                            // let map_path = "model-box/transparent/transparent2.png";
                            // const material = child.material;
                            // const map_texture = new THREE.TextureLoader().load(
                            //   map_path
                            // );
                            // material.map = map_texture;
                            child.material.transparent = true
                            child.material.opacity = 0.5 // 设置透明度为0.5（半透明）
                            // child.material.alphaTest = 0; // 禁用alphaTest（如果需要的话）
                        } else {
                            child.material.transparent = false
                            child.material.opacity = 1
                        }
                    }
                })
            }
        },

        //调整光照参数
        AmbientLight_intensity_change(value) {
            console.log('光照强度', value)

            this.ambitlight.intensity = value
            // this.animate();
            renderer.render(scene, camera)
            console.log('更新环境光强度的影响')
        },

        AmbientLight_remove() {
            scene.remove(this.ambitlight)
            renderer.render(scene, camera)
            console.log('移除环境光 更新')
        },

        change_model_url(model_url) {
            console.log('切换模型链接')

            // 4鼓  支撑器 2 3 6
            // https://hailungushang.com/assets/model/4/4_TH900.gltf
            // https://hailungushang.com/assets/model/4/vintage.gltf
            // https://hailungushang.com/assets/model/4/4_TH700.gltf

            // 5鼓 支撑器 2 4 5
            // https://hailungushang.com/assets/model/5/5_TH900.gltf
            // https://hailungushang.com/assets/model/5/5_DTH700.gltf
            // https://hailungushang.com/assets/model/5/5_DTH500.gltf

            // 6鼓 支撑器 2 4 5
            // https://hailungushang.com/assets/model/6/6_TH900.gltf
            // https://hailungushang.com/assets/model/6/6_DTH700.gltf
            // https://hailungushang.com/assets/model/6/6_DTH500.gltf

            // 7鼓 支撑器 1 2
            // https://hailungushang.com/assets/model/7/qigu.gltf

            // let url = `https://hailungushang.com/assets/model/4/4_TH900.gltf`
            let url = model_url || `./model-box/model/4/4_TH900.gltf`
            this.loadNewModel(url)
        },

        //加载 新模型
        loadNewModel(url) {
            return new Promise(async (resolve, reject) => {
                // this.loading = true
                // this.$load.open()
                const dracoLoader = new DRACOLoader()
                dracoLoader.setDecoderPath(this.decodePath)
                model_loader.setDRACOLoader(dracoLoader)
                model_loader.load(
                    url,
                    (gltf) => {
                        // 移除当前模型
                        if (currentModel) {
                            scene.remove(currentModel.scene)
                        }
                        // 存储新加载的模型
                        currentModel = gltf
                        // 将新模型添加到场景中
                        scene.add(gltf.scene)

                        model = gltf.scene
                        resolve()
                        //设置初始化参数
                        // this.init_gu_config_1()
                    },
                    undefined,
                    (error) => {
                        console.error(error)
                    }
                )
            })
        },
    },
}
</script>

<style scoped lang="less">
#WebGL-output {
    width: 100%;
    height: 550px;
    margin: 0 auto;

    /deep/canvas {
        margin: 0 auto !important;
    }
}

.webGlDiv {
    position: relative;
    top: 10px;
}

.huanse {
    display: flex;
    justify-content: center;
    position: absolute;
    left: 50%;
    transform: translate(-50%);
}

[class*='btn-'] {
    width: 120px;
    height: 40px;
    background: coral;
    font-size: 14px;
    color: #fff;
    border: 1px solid #ccc;
    outline: none;
}

.light-box {
    position: absolute;
    top: 0;
    right: 0;

    .light-item {
        margin-bottom: 15px;
        padding: 10px;
        background: #ccc;

        .light-title {
        }

        .light-slider {
            width: 300px;
        }
    }
}

@media screen and (max-width: 1024px) {
    .webGlDiv {
        top: 135px !important;
    }
}
</style>
